export default __webpack_public_path__ + "static/media/deposit.0e5cea1c.svg";